import { FanCheckInInfo } from "../../models/fanCheckInInfo";
import { useTranslation } from "react-i18next";
import {
  fanCheckInStatusColor,
  fanCheckInStatusToString,
  TicketCheckInStatus,
} from "../../models/enum/ticketCheckInStatus";
import { FanViewLanguage } from "../../models/enum/fanViewLanguage";
import { CollapseText } from "./collapseText";
import { actionOn } from "../../models/enum/actionOn";

interface CheckInInfoProps {
  fanInfo?: FanCheckInInfo | null;
}

export function CheckInInfoView({ fanInfo }: CheckInInfoProps) {
  const { t, i18n } = useTranslation();
  const showCustom = !!(
    fanInfo?.winner.customMessageInfo && i18n.resolvedLanguage
  );

  return (
    <>
      <div
        className={
          "rounded-md bg-base-200/50 p-3 m-2 flex items-center gap-3 justify-center flex-col"
        }
      >
        <div className={"flex gap-2"}>
          {(fanInfo?.penalty.disadvantages?.length || 0) > 0 && (
            <label className={"badge badge-error"}>
              {t("userdetail_da_badge")}
            </label>
          )}
          <label
            className={`badge ${fanCheckInStatusColor(fanInfo?.ticketStatus)}`}
          >
            {fanCheckInStatusToString(fanInfo?.ticketStatus)}
          </label>
        </div>
        {fanInfo?.isTardy() ? (
          <div className={"flex items-baseline gap-2"}>
            <label className={"font-bold"}>{fanInfo?.tardyOrderString()}</label>
            <label className={"text-sm text-gray-500"}>
              {fanInfo?.orderString()}
            </label>
          </div>
        ) : (
          <label className={"font-bold"}>{fanInfo?.orderString()}</label>
        )}
      </div>
      {showCustom && (
        <CollapseText
          summary={fanInfo!.winner.customMessageInfo!.getShortMessage(
            i18n.resolvedLanguage as FanViewLanguage,
          )}
          details={fanInfo!.winner.customMessageInfo!.getMessage(
            i18n.resolvedLanguage as FanViewLanguage,
          )}
        />
      )}
      {fanInfo?.ticketStatus === TicketCheckInStatus.CHECKED_IN && (
        <div className={"flex flex-col rounded-md bg-base-200 p-3 m-2 text-xs"}>
          <label>{`${t("userdetail_checkininfo_timestamp")}: ${fanInfo?.ticket?.checkInAt?.format(t("datetime2_format"))}`}</label>
          <label>{`${t("userdetail_checkininfo_manager")}: ${fanInfo?.ticket.checkInBy}`}</label>
        </div>
      )}
    </>
  );
}
